<template>
    <div id="text-center">
        <!-- >>> The Settings Menu -->
        <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-width="400"
            :max-width="$isDesktop() ? '100%' : '90%'"
            max-height="90%"
            bottom
            left
            origin="top right"
            transition="scale-transition"
            offset-y>
            <template v-slot:activator="{ on }">
                <v-btn class="ml-10" raised elevation="1" min-width="0" text small v-on="on">
                    <v-icon> mdi-information</v-icon>
                </v-btn>
            </template>
            <v-card class="mb-0" width="350" max-height="80%" style="overflow: auto;">
                <v-card-title class="headline">
                    <p class="pl-7 mb-8 mt-8">
                        Explanation
                    </p>
                </v-card-title>

                <v-card-text class="pa-5">
                    <strong class="d-inline-block">WARNINGS ON FLIGHT</strong>

                    <div class="py-2 ">
                        <v-row
                            v-for="(warning, i) in warnings"
                            :key="i"
                            style="margin:0 0;align-items:center;">
                            <v-col md="4">
                                <div style="position:relative;width:100%;height:40px;border:1px solid black;margin-right:10px;" :style="warning.style">
                                    <div
                                        v-if="warning.additionalDiv && warning.additionalDivPosition === 'left'"
                                        style="position: absolute; left: 0; bottom: 0; width: 20px; height: 20px; background: purple; clip-path: polygon(0 0, 100% 100%, 0 100%)" />
                                    <div
                                        v-if="warning.additionalDiv && warning.additionalDivPosition === 'right'"
                                        style="position: absolute; right: 0; bottom: 0; width: 20px; height: 20px; background: purple; clip-path: polygon(100% 0, 100% 100%, 0 100%)" />
                                </div>
                            </v-col>
                            <v-col md="8">
                                <strong v-if="warning.type !== ''" class="d-inline-block">{{ warning.type }}</strong>
                                <div>{{ warning.description }}</div>
                            </v-col>
                        </v-row>
                    </div>
                </v-card-text>
            </v-card>
        </v-menu>
    </div>
    <!-- <<< The Settings Menu -->
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';


    export default {
        name: 'Explanation',


        /* >>> *************************************************************** / /* Data */
        data: () => ({

            menu: false,

            warnings: [
                {
                    type: 'Airport transition',
                    description: "Airport doesn't fit to next Destination Airport",
                    style: 'border-right:8px solid orange'
                },
                {
                    type: 'Airport transition',
                    description: "Airport doesn't fit to previous Departure Airport",
                    style: 'border-left:8px solid orange'
                },
                {
                    type: 'Flight Number',
                    description: 'Flight Number already exists on that day',
                    style: 'border-top:8px solid yellow'
                },
                {
                    type: 'Overlapping flight',
                    description: 'Two or more flights collide',
                    style: 'border-bottom:8px solid red'
                },
                {
                    type: 'Missing Slot',
                    description: 'Departure Slot is missing',
                    style: '',
                    additionalDiv: true,
                    additionalDivPosition: 'left'
                },
                {
                    type: 'Missing Slot',
                    description: 'Destination Slot is missing',
                    style: '',
                    additionalDiv: true,
                    additionalDivPosition: 'right'
                }
            ]
        }), // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([])

        },
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
		created: function() {

            const me = this;


            me.$toc('>>> components/core/Settings.vue >>> created');

		}, // eo function created()
		/* <<< ****************************************************************/


        /***********************************************************************
        * Lifecyclehook::destroyed
        *
        * Desc:
        * Note:
        *
        */
		destroyed: function() {

            const me = this;


            me.$toc('>>> components/core/Settings.vue >>> destroyed');

		}, // eo function destoryed()
		/* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([])



        } // eof methods()
        /* <<< ****************************************************************/

    };
</script>

<style lang="sass">
.v-settings
    .v-item-group > *
        cursor: pointer

    &__item
        border-width: 3px
        border-style: solid
        border-color: transparent !important

    &--active
        border-color: #00cae3 !important
.sdr-chip--active
    background: #AB3B7A
    .v-chip__content
        color: #FFFFFF
.sdr-custom-text-input
    input
        text-transform: uppercase
</style>
<style>
    .test .v-menu__content {
        max-height: 90% !important;
    }
</style>

